// src/hooks/analysis/summary/extractions.ts

import { useMemo } from 'react';
import { AnalysisValueView } from 'src/api/generated';
import { getExtractions } from 'src/utils/analysisValues/extractions/extractions';

export const useExtractions = (analysisValues: AnalysisValueView[]) => {
  return useMemo(() => getExtractions(analysisValues), [analysisValues]);
};
